import { Load } from './GridStackEngine';

namespace SignalHub.Browser.Layouts {
    export function Main() {
        Load();
    }
}

SignalHub.Browser.Layouts.Main();